var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNftFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9345 10.5007C7.65975 10.5007 8.247 11.0887 8.247 11.8132V14.4382C8.247 14.7863 8.10872 15.1201 7.86258 15.3663C7.61644 15.6124 7.2826 15.7507 6.9345 15.7507H2.8125C2.4644 15.7507 2.13056 15.6124 1.88442 15.3663C1.63828 15.1201 1.5 14.7863 1.5 14.4382V11.8132C1.5 11.0887 2.088 10.5007 2.8125 10.5007H6.9345ZM15.1875 10.5007C15.912 10.5007 16.5 11.0887 16.5 11.8132V14.4382C16.5 14.7863 16.3617 15.1201 16.1156 15.3663C15.8694 15.6124 15.5356 15.7507 15.1875 15.7507H11.0655C10.7174 15.7507 10.3836 15.6124 10.1374 15.3663C9.89128 15.1201 9.753 14.7863 9.753 14.4382V11.8132C9.753 11.0887 10.3403 10.5007 11.0655 10.5007H15.1875ZM15.1875 2.24695C15.912 2.24695 16.5 2.83495 16.5 3.55945V7.6867C16.5001 7.85912 16.4662 8.02987 16.4003 8.1892C16.3344 8.34853 16.2377 8.4933 16.1158 8.61526C15.994 8.73722 15.8492 8.83396 15.6899 8.89997C15.5307 8.96597 15.3599 8.99995 15.1875 8.99995H2.8125C2.4644 8.99995 2.13056 8.86167 1.88442 8.61553C1.63828 8.36938 1.5 8.03554 1.5 7.68745V3.55945C1.50001 3.23006 1.62388 2.91271 1.84701 2.6704C2.07014 2.4281 2.37622 2.27855 2.7045 2.25145L2.8125 2.24695H15.1875Z",
    fill: "#C4C5CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftFeed);
export default __webpack_public_path__ + "static/media/nftFeed.eccbc42c85df841ad63cf4d1b331b299.svg";
export { ForwardRef as ReactComponent };